module.exports = __webpack_public_path__ + "img/s1-1.4b7be80c.jpg";